import React from "react";
import "../CSS/HowWeWork.css";
import { Link } from "react-router-dom";

function HowWeWork() {

  const processSteps = [
    {
      icon: "bi-chat-square-text",
      title: "Understand Your Requirements",
      description:
        "We start by understanding your business, goals, challenges, users, and the type of technology solution you need."
    },
    {
      icon: "bi-clipboard-check",
      title: "Planning & Analysis",
      description:
        "We analyze the requirements and prepare a clear project plan covering features, technology, database, design, and development approach."
    },
    {
      icon: "bi-palette",
      title: "UI/UX & Solution Design",
      description:
        "We create the structure and user experience of your website, software, or application with a focus on simplicity and usability."
    },
    {
      icon: "bi-code-slash",
      title: "Development",
      description:
        "Our developers build the solution using suitable technologies such as .NET, C#, React, Angular, PHP, SQL, MongoDB, and other technologies."
    },
    {
      icon: "bi-bug",
      title: "Testing & Quality Check",
      description:
        "We test the solution to identify functional issues, usability problems, compatibility issues, and other technical requirements."
    },
    {
      icon: "bi-cloud-upload",
      title: "Deployment",
      description:
        "Once the solution is ready, we help deploy your website, application, software, database, or cloud solution."
    },
    {
      icon: "bi-headset",
      title: "Support & Maintenance",
      description:
        "After deployment, we can provide ongoing maintenance, updates, improvements, troubleshooting, and technical support."
    }
  ];

  const technologies = [
    {
      title: "Frontend Development",
      description:
        "Modern and responsive interfaces using React, Angular, JavaScript, HTML, CSS, and other frontend technologies."
    },
    {
      title: "Backend Development",
      description:
        "Reliable backend systems using .NET, C#, PHP, APIs, and other technologies according to project requirements."
    },
    {
      title: "Database Solutions",
      description:
        "Structured and scalable data solutions using SQL databases, MongoDB, and other database technologies."
    },
    {
      title: "Cloud & Deployment",
      description:
        "Deployment and hosting solutions designed around the requirements, scale, and infrastructure of your project."
    }
  ];


  return (
    <>
      
      {/* =====================================================
                HERO
            ===================================================== */}

      <section className="how-work-hero">

        <div className="container">

          <div className="how-work-hero-content">

            <h1>
              A Clear Process <br />
              <span>
                From Idea To Solution
              </span>
            </h1>

            <p>
              We follow a structured and transparent approach to
              understand your requirements, develop the right
              solution, and help your business move forward with
              technology.
            </p>
            <div className="about-hero-buttons">
              <Link to="/contactus" className="about-primary-button" >
                Let's Work Together
              </Link>
              <Link to="/services" className="about-secondary-button" >
                Explore Our Services
              </Link>
            </div>
          </div>

        </div>

      </section>


      {/* =====================================================
                INTRODUCTION
            ===================================================== */}

      <section className="how-work-intro">

        <div className="container">

          <div className="row align-items-center g-5">

            <div className="col-lg-6">

              <div className="how-work-intro-content">
                <h2>
                  Business-Driven Technology Development
                </h2>
                <p>
                  From websites and web applications to
                  custom software, mobile applications,
                  databases, and digital solutions, we follow
                  a step-by-step process to keep projects
                  organized and focused.
                </p>

              </div>

            </div>


            <div className="col-lg-6">

              <img
                src="/images/industries/our-approach.png"
                alt="Our Technology Development Approach"
                className="how-work-intro-image"
              />

            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
                PROCESS
            ===================================================== */}

      <section className="how-work-process">
        <div className="container">
          <div className="section-heading text-center">
            <h2>
              Turning Ideas Into Real Solutions
            </h2>
          </div>

          <div className="process-timeline">

            {processSteps.map((step) => (

              <div
                className="work-process-card"
                key={step.title}
              >

                <div className="work-process-icon">
                  <i className={`bi ${step.icon}`}></i>
                </div>

                <div className="work-process-content">

                  <h3>
                    {step.title}
                  </h3>

                  <p>
                    {step.description}
                  </p>

                </div>

              </div>

            ))}

          </div>

        </div>

      </section>


      {/* =====================================================
                TECHNOLOGY
            ===================================================== */}

      <section className="how-work-technology">

        <div className="container">

          <div className="section-heading text-center">

            <h2>
              Smart Technology for Business
            </h2>

          </div>


          <div className="technology-work-grid">

            {technologies.map((technology) => (

              <div
                className="technology-work-card"
                key={technology.title}
              >

                <div className="technology-work-icon">
                  ✓
                </div>

                <h3>
                  {technology.title}
                </h3>

                <p>
                  {technology.description}
                </p>

              </div>

            ))}

          </div>

        </div>

      </section>


      {/* =====================================================
                COMMUNICATION
            ===================================================== */}

      <section className="communication-section">

        <div className="container">

          <div className="row align-items-center g-5">

            <div className="col-lg-6">

              <img
                src="/images/industries/client-communication.png"
                alt="Client Communication"
                className="communication-image"
              />

            </div>


            <div className="col-lg-6">

              <div className="communication-content">

                <h2>
                  Clear Communication Throughout The Project
                </h2>

                <p>
                  We believe good communication is an
                  important part of successful software and
                  digital projects.
                </p>

                <p>
                  We keep requirements, progress, changes,
                  and project discussions clear so that you
                  can stay informed throughout the development
                  process.
                </p>


                <div className="communication-points">

                  <div className="communication-point">
                    <span>
                      <i className="bi bi-file-earmark-text"></i>
                    </span>
                    <p>
                      Clear project requirements
                    </p>
                  </div>

                  <div className="communication-point">
                    <span>
                      <i className="bi bi-chat-dots"></i>
                    </span>
                    <p>
                      Regular project communication
                    </p>
                  </div>

                  <div className="communication-point">
                    <span>
                      <i className="bi bi-eye"></i>
                    </span>
                    <p>
                      Transparent development process
                    </p>
                  </div>

                  <div className="communication-point">
                    <span>
                      <i className="bi bi-headset"></i>
                    </span>
                    <p>
                      Ongoing technical support
                    </p>
                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
                CTA
            ===================================================== */}

      <section className="how-work-cta">

        <div className="container">

          <div className="how-work-cta-box">

            <div>

              <span>START YOUR PROJECT</span>

              <h2>
                Have An Idea? Let's Build It Together.
              </h2>

              <p>
                Tell us about your business, requirements, or
                project idea and let's discuss how technology
                can help you achieve your goals.
              </p>

            </div>


            <a
              href="/contactus"
              className="how-work-cta-button"
            >
              Get In Touch
            </a>

          </div>

        </div>

      </section>

    </>
  );
}

export default HowWeWork;